<template>
    <rkm-overlay>
        <rkm-layout-body title="Dispensação de materiais">
            <rkm-layout-content>
                <List>
                    <template #actions="{ item }">
                        <rkm-button
                            @click="redirectToDispensacao(item)"
                            class="align-self-end"
                            color="primary"
                            title="Dispensar"
                            small
                        >
                            <rkm-icon icon="hand-holding-medical"/>
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/almoxarifado/dispensacao-materiais/List'

export default {
    components: {
        List
    },
    methods: {
        redirectToDispensacao(paciente) {
            this.$router.push({ name: 'almoxarifado-dispensacao-materiais-create', params: { pacienteId: paciente.id }})
        },
    }
}
</script>